import { Api } from "@/core/api.js";
const api = new Api();

// initial state
const state = {
  user: {},
  exp: -1,
  login: null,
  userLoadStatus: 0,
  users: {},
  selected_user: false
};

// getters
const getters = {
  getSession(state) {
    return { user: state.user, exp: state.exp, login: state.login };
  },
  /*
        Returns the user load status.
    */
  getUserLoadStatus(state) {
    return function() {
      return state.userLoadStatus;
    };
  },

  getUser(state) {
    return state.user;
  },

  getUsers(state) {
    return state.users;
  },

  getUserSelected(state) {
    return state.selected_user;
  }
};

const actions = {
  loadUsers({ commit }, user_selected) {
    return api.get("user").then(function(data) {
      console.log(data);
      if (data.status) {
        console.log(data.data);
        return commit("setUsers", data.data, user_selected);
      }
    });
  }
};
const mutations = {
  setAuthenticate(state, data) {
    console.log("setAuthenticate");
    if (!data) {
      state = {
        user: {},
        exp: -1,
        login: null,
        userLoadStatus: 0
      };
    } else {
      state.user = data.user;
      state.user.letter = data.user.name.substring(0, 1).toUpperCase();
      state.exp = data.exp;
      state.login = moment();
      state.userLoadStatus = 2;
    }
    return true;
  },

  logoutUser(state) {
    state = {
      user: {},
      exp: -1,
      login: null,
      userLoadStatus: 0,
      users: {}
    };
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
